<script lang="ts">
import { onDestroy } from 'svelte';
import { getPoll, vote as apiVote } from './services';
import { pusher } from './store';
import type { Poll } from './services';
import { from } from 'rxjs';
import ProgressBar from './ProgressBar.svelte';

export let showId;

const Colors = [
  '#F2994A',
  '#219653',
  '#9B51E0',
  '#56CCF2',
  '#EB5757'
];

const ACharCode = 65;

let poll: Poll;
let pollSub;
let channel;

let percents;
let totalVotes = 0;

function pollUpdate() {
  if (!poll) return;

  const counts = poll.counts;
  totalVotes = counts.reduce((a, c) => a += c, 0)

  if (totalVotes === 0) {
    // Don't DIV by 0
    percents = counts.map(c => 0);
  } else {
    percents = counts.map(c => c / totalVotes);
  }
}

$: pollUpdate(poll)

onDestroy(() => {
  pollSub?.unsubscribe();
  channel?.unbind();
})

function rebind() {
  channel?.unbind();
  pollSub?.unsubscribe();
  poll = undefined;

  channel = pusher.subscribe(`poll-${showId}`);
  channel.bind('start', (_poll: Poll) => {
    console.log('start', _poll)
    poll = _poll;
  });

  channel.bind('update', (counts: number[]) => {
    console.log('update', counts)
    if (poll) poll.counts = counts;
    poll = poll;
  });

  channel.bind('close', data => {
    console.log('close', data)
    if (poll) poll.state = 'close';
    poll = poll;
  });

  channel.bind('end', data => {
    console.log('end', data)
    poll = undefined;
  });

  pollSub = from(getPoll(showId)).subscribe(_poll => {
    console.log('getPoll', _poll)
    poll = _poll;
  });
}

$: rebind(showId)

async function vote(index) {
  if (poll.state !== 'running' || poll.vote != undefined) return;

  const counts = await apiVote(showId, index);
  if (poll) {
    poll.vote = index;
    poll.counts = counts;
    poll = poll;
  }
}
</script>

{#if poll}
  <div class="bar mb-4 rowtocol">
    <div class="livepoll row vcenter hcenter">Live Poll</div>

    {#if poll.type === 'yesno'}
      <div class='row flex-1 vcenter end yesnoquestionbox'>
        <div class="question col vcenter">{poll.question}</div>

        {#if (poll.vote == null && poll.state === 'running')}
          <div class="thumbup row vcenter hcenter cursor-pointer" on:click={() =>vote(0)}>
            <i class="material-icons" style="color: white">thumb_up</i>
          </div>

          <div class="thumbdown row vcenter hcenter cursor-pointer" on:click={() =>vote(1)}>
            <i class="material-icons" style="color: white">thumb_down</i>
          </div>
        {:else if (poll.vote != null)}
          <div class="row vcenter">
            <div class={`row vcenter hcenter thumb${poll.vote === 0 ? 'up' : 'down'}`}>
              <i class="material-icons" style="color: white">{poll.vote === 0 ? 'thumb_up' : 'thumb_down'}</i>
            </div>
            <div class={`thumb${poll.vote === 0 ? 'up' : 'down'}-color`}>
              Your<br>
              Response
            </div>
          </div>
        {/if}
      </div>
      <div class='row flex-1 vcenter'>
        <div class="vr" />

        <div class="col flex-1 vote-box">
          <div class='liveresponse'>Live Response</div>
          {#if totalVotes > 0}
            <ProgressBar percents={percents.slice().reverse()} />
          {:else}
            No votes yet
          {/if}
        </div>
      </div>
    {:else}
      <!-- Multiple choice -->
      <div class="question-mult col vcenter">{poll.question}</div>
      <div class="vr" />
      <div class="col flex-1 vote-box">
        {#each poll.answers as answer, i}
          <div class="vote-bar row" class:disabled={poll.vote != undefined || poll.state !== 'running'} on:click={() => vote(i)}>
            <div class="vote-tally">{poll.vote != undefined ? Math.floor(percents[i] * 100) + '%' : String.fromCharCode(ACharCode + i)}</div>
            <div class="vote-answer row">
              {#if poll.vote === i}
                <i class="material-icons" style="margin-top: -3px; color: lime;">check</i>
              {/if}
              {answer}
            </div>
            {#if poll.vote != undefined}
              <div class="vote-fill" style="width: {percents ? percents[i] * 100 : 0}%; background-color: {Colors[i]}" />
            {:else}
              <div class="vote-fill" style="background-color: {Colors[i]}" />
            {/if}
          </div>
        {/each}
      </div>
    {/if}
  </div>
{/if}

<style lang='scss'>
@import './util';

.yesnoquestionbox {
  margin: 16px;
  margin-left: 0;
  @include mobile {
    justify-content: center;
  }
}

.liveresponse {
  margin-bottom: 8px;
}

.vote-box {
  margin: 16px 32px;
}

.vote-bar {
  padding-top: 6px;
  min-height: 32px;
  width: 100%;
  position: relative;
  margin-bottom: 2px;
  z-index: 2;
  border-radius: 5px;
  cursor: pointer;
}

.vote-bar.disabled {
  cursor: unset;
}

.vote-fill {
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  height: 32px;
  border-radius: 0px 0px 15px 0px;
  min-width: 44px;
}

.vote-answer {
  color: black;
}

.vote-tally {
  color: white;
  width: 44px;
  padding-left: 8px;
  margin-right: 8px;
  flex-shrink: 0;
}

.bar {
  background-color: white;
  @include shadow;
}

.question, .question-mult {
  margin: 16px;
  // margin-right: 16px;
  width: 50%;
  max-width: 400px;
  font-weight: bold;
  text-align: right;

  @include mobile {
    width: unset;
    max-width: unset;
  }
}

.question-mult {
  @include mobile {
    text-align: center;
    margin: 16px;
  }
}

.vr {
  width: 1px;
  height: 48px;
  background-color: black;
  margin: 0 12px;
  align-self: center;

  @include mobile {
    display: none;
  }
}

.livepoll {
  background-color: var(--secondary);
  color: var(--text-secondary);
  font-size: 20px;
  font-weight: bold;
  padding: 12px 24px;

  @include mobile {
    display: none;
  }
}

.thumbup, .thumbdown {
  width: 48px;
  height: 48px;
  border-radius: 24px;
  margin: 3px;
  flex-shrink: 0;
}

$thumbdown-color: rgb(253, 116, 118);
$thumbup-color: rgb(48, 196, 99);

.thumbdown {
  background-color: $thumbdown-color;
}

.thumbup {
  background-color: $thumbup-color;
}

.thumbup-color {
  color: $thumbup-color;
}

.thumbdown-color {
  color: $thumbdown-color;
}
</style>